import { getProfilIdFromUrlName } from "./chatProfileUtils";

// Messages de confirmation pour les photos débloquées (version ultra sexy et suggestive)
export const unlockMessages = [
  "Prends-moi... Cette photo est là pour que tu m'imagines à ta merci.",
  "Je suis à toi maintenant... Regarde bien et imagine ce que tu pourrais me faire.",
  "Cette image est une invitation... Viens me prendre comme tu en as toujours rêvé.",
  "Je t'attends... Regarde cette photo et imagine tes mains sur mon corps.",
  "Je suis là, offerte à toi... Laisse ton esprit divaguer et prends-moi comme tu le désires.",
  "Cette photo est une promesse... Une promesse de ce que tu pourrais me faire si j'étais là.",
  "Je suis toute mouillée à l'idée que tu me regardes... Prends-moi, je suis à toi.",
  "Regarde bien et imagine... Imagine ta bouche sur moi, tes mains qui me possèdent.",
  "Je suis là, prête pour toi... Cette photo n'est qu'un avant-goût de ce que je pourrais t'offrir.",
  "Prends-moi, je suis toute à toi... Laisse cette photo t'inspirer et viens me chercher."
];



// Validation du token (simulation)
export const validateToken = (token) => {
  // Pour l'instant, on simule une validation
  // En production, tu vérifieras côté serveur
  return token && token.length >= 4;
};

// Extraction du token depuis l'URL
export const extractTokenFromUrl = () => {
  const url = window.location.pathname;
  // /NomProfil/{token}
  const match = url.match(/^\/([^\/]+)\/([a-zA-Z0-9]+)/);
  if (match) {
    const profilName = match[1];
    const token = match[2];
    const photoId = getProfilIdFromUrlName();
    return {
      photoId,
      token
    };
  }
  return null;
};

// Génération d'un token (pour les tests)
export const generateToken = () => {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
}; 